import RevolvingFundsError from './RevolvingFundsError';
class InvalidPropertyId extends RevolvingFundsError {
    propertyId;
    constructor(propertyId, options) {
        super('The id provided doesn\'t have a valid format', options);
        this.propertyId = propertyId;
    }
}
export default InvalidPropertyId;
